/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ZgloszenieStatus {
  Zatwierdzony = 'ZATWIERDZONY',
  Nowy = 'NOWY',
  Niepoprawny = 'NIEPOPRAWNY',
  DoWyjasnienia = 'DO_WYJASNIENIA',
  Papierowy = 'PAPIEROWY'
}
